import { AccountingPeriodBlock } from '../../models/AccountingPeriodBlock.model';

export const isBlockPeriodInvalid = ({competence, competenceYear}, accountingBlock: AccountingPeriodBlock, isApproval = false) => {
    let totalBlocking = null;
    if(accountingBlock) {
        if (competence && competenceYear) {
            totalBlocking = Number(accountingBlock.competenceYear) + (Number(accountingBlock.competence) / 100);
            let itemTotal = null;
            if (isApproval) competence = Number(competence) + 1;
            itemTotal = Number(competenceYear) + ((Number(competence))  / 100);
            if (itemTotal && totalBlocking && itemTotal <= totalBlocking) {
                return true
            }
        }
    };
    return false;
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/validate-block-period.ts